<template>
  <div class="mb5 input_foreign-key">
    <input class="form-control" type="text" :value="formattedValue" readonly />
    <div v-if="value" class="input__buttons">
      <div>
        <button
          class="btn btn-default btn-icon"
          type="button"
          @click="$emit('on-trash-click')"
          :disabled="disabled"
        >
          <i class="fa fa-trash"></i>
        </button>
      </div>
      <div>
        <button
          class="btn btn-default btn-icon"
          type="button"
          @click="goToAnotherForm"
        >
          <i class="fa fa-link"></i>
        </button>
      </div>
    </div>
    <button
      v-else
      class="btn btn-default btn-icon"
      type="button"
      :disabled="disabled"
      @click="$emit('on-plus-click')"
    >
      <i class="fa fa-plus"></i>
    </button>
  </div>
</template>

<script>
export default {
  emits: ["on-plus-click", "on-trash-click"],
  props: {
    fieldName: {
      type: String,
      default: 'name',
    },
    value: {
      type: Object | String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    recordLink: {
      type: String | Function,
      default: "/products/1",
    },
  },
  computed: {
    formattedValue() {
      if (!this.value) {
        return "Не выбрано";
      }
      return `${this.value[this.fieldName]} (${this.value.id})`;
    },
  },
  methods: {
    goToAnotherForm() {
      const routeData = this.$router.resolve(this.recordLink);
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped>
.input_foreign-key {
  display: inline-flex;
  flex-direction: row;
  column-gap: 0.5em;
}
.input__buttons {
  display: inline-flex;
  flex-direction: row;
}
.input__buttons > div:first-child {
  margin-right: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/ForeignKeyInput.vue